import { applyMiddleware, compose, createStore } from "redux";
import thunkMiddleware from "redux-thunk";

import rootReducer from "./rootReducer";

const middleswares = [thunkMiddleware];

const store = () => {
  let finalCreateStore = compose(applyMiddleware(...middleswares))(createStore);

  return finalCreateStore(rootReducer);
};

export default store;
